import React from 'react';
import LocationTemplate from './LocationTemplate';

const EdentonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Edenton"
      stateName="North Carolina"
      countyName="Chowan"
      zipCodes={["27932"]}
      latitude={36.0579}
      longitude={-76.6078}
      population={4397}
      historicalFact="One of North Carolina's oldest towns (1712), site of the famous Edenton Tea Party in 1774."
      nearbyTowns={[
        "Elizabeth City, NC",
        "Windsor, NC",
        "Plymouth, NC",
        "Columbia, NC",
        "Hertford, NC",
        "Colerain, NC",
        "Ahoskie, NC",
        "Manteo, NC"
      ]}
    />
  );
};

export default EdentonPage;